module.exports = __webpack_public_path__ + "static/media/layer-0-1-at-1x.69ad93f5.webp";